import React from 'react';
export function Footer() {
  return <footer className="w-full bg-ink text-cream/60" data-id="element-58" data-mp="32wd2qgad7ltj">
      <div className="mx-auto flex max-w-6xl flex-col gap-2 px-5 py-10 text-center font-sans text-sm sm:flex-row sm:items-center sm:justify-between sm:text-left" data-id="element-59" data-mp="3gfsoch60l2p3">
        <p className="font-display text-base font-bold text-cream" data-id="element-60" data-mp="32lrnnhvi55m3">Cocina en 3 Horas</p>
        <p data-id="element-61" data-mp="36ppn5toqoifo">Pago único · Acceso digital inmediato · Garantía de 7 días</p>
      </div>
    </footer>;
}